import { json, useLoaderData, useNavigation, wordpressLoader } from '@ubo/losse-sjedel'
import { type LoaderData, type LoaderFunction } from '@ubo/losse-sjedel'
import Progress from 'nprogress'
import { useEffect } from 'react'

import FlexContentHandler from '~/components/flex/FlexContentHandler'
import Layout from '~/components/layout/Layout'
import { replaceWordpressUrlInFullHead } from '~/services/seo.server'

export const loader: LoaderFunction = async (args) => {
  const { body, headers } = await wordpressLoader(args)

  if (body.page?.seo?.fullHead) {
    const siteUrl = new URL(args.request.url).origin.replace(':80', '')
    body.page.seo.fullHead = replaceWordpressUrlInFullHead(body.page.seo.fullHead, siteUrl)
  }

  return json(body, headers)
}

export default function $page() {
  const { page } = useLoaderData<LoaderData>()

  const navigation = useNavigation()

  useEffect(() => {
    if (navigation.state === 'loading' || navigation.state === 'submitting') {
      Progress.start()
    } else {
      Progress.done()
    }
  }, [navigation.state])

  return (
    <Layout>
      <FlexContentHandler prefix={`${page?.contentType?.node?.name}_Flexcontent`} flex={page?.flexContent?.flex} />
    </Layout>
  )
}
